// extracted by mini-css-extract-plugin
export default {"myOrdersTable":"KTZBfrkeoa62o28GJEN3wg=="};